import { AspectRatio, Box, Flex, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'
import BuyButton from './buy-button'

const ColorItem = ({
  color,
  title,
  textColor = '#000'
}: {
  color: string
  title: string
  textColor?: string
}) => {
  return (
    <Flex
      bgColor={color}
      w={{
        base: '80px',
        sm: '90px',
        md: '110px',
        lg: '160px',
        xl: '180px'
      }}
      h={{
        base: '24px',
        sm: '30px',
        md: '36px',
        lg: '54px'
      }}
      alignItems="center"
      justifyContent="center"
      color={textColor}
      borderRadius={40}
      fontSize={{
        base: 12,
        sm: 14,
        md: 16,
        lg: 18,
        xl: 20,
        '2xl': 26
      }}
      fontWeight={700}
    >
      {title}
    </Flex>
  )
}

const Colors = () => {
  return (
    <VStack w="100%">
      <Text
        textStyle="gripHeroTitle"
        textTransform="uppercase"
        textAlign={{
          base: 'left',
          sm: 'right'
        }}
        w="100%"
        fontWeight={600}
        fontFamily={'Inter'}
      >
        ARCTIC GRIP TUMBLER
      </Text>
      <Text
        textStyle="gripHeroTitle"
        textAlign={{
          base: 'left',
          sm: 'right'
        }}
        w="100%"
      >
        Japandi Series
      </Text>
      <VStack
        w="100%"
        alignItems={{
          base: 'flex-start',
          sm: 'flex-end'
        }}
      >
        <ColorItem title="Silver" color="#bdbcb8" />
        <ColorItem title="Black" color="#000000" textColor="#fff" />
        <ColorItem title="Cool Sage" color="#adbeb0" />
        <ColorItem title="Ivory" color="#edf1e6" />
        <ColorItem title="Adrift Blue" color="#adbfd1" />
      </VStack>
      <VStack
        w="100%"
        alignItems={{
          base: 'flex-start',
          sm: 'flex-end'
        }}
      >
        <BuyButton />
      </VStack>
    </VStack>
  )
}

const Hero = () => {
  return (
    <Box pt={10} w="100%">
      <VStack w="100%" alignItems="flex-start">
        <AspectRatio
          mt={5}
          w={{
            base: '120px',
            sm: '120px',
            md: '180px',
            lg: '200px',
            xl: '260px'
          }}
          ratio={236 / 40}
          position="relative"
        >
          <Image
            src="https://d1i7lep6rvr4o.cloudfront.net/IUHdaBiysmkJiKjES8xERvU47Pw=/fit-in/3840x0/smart/filters:quality(80):format(webp)/https://habbit-sg.s3.ap-southeast-1.amazonaws.com/brand-detail-banner-logo-1-1685459512540-1686670277118.png"
            alt="hero"
            fill
          />
        </AspectRatio>
        <Text
          textStyle="gripMainTitle"
          textTransform="uppercase"
          textAlign="center"
        >
          Grip Tumbler
        </Text>
        <Text
          textStyle="gripContentLarge"
          textTransform="uppercase"
          textAlign="left"
          maxW={{
            base: 450,
            lg: 600,
            xl: 700
          }}
          mt={{
            base: 1,
            lg: 4
          }}
        >
          THE TUMBLER THAT NEVER TOPPLES
        </Text>
      </VStack>
      <Flex
        justifyContent="space-between"
        mt="50px"
        flexDir={{
          base: 'column',
          sm: 'row',
          md: 'row'
        }}
      >
        <VStack
          w={{
            base: '80%',
            sm: '60%',
            md: '60%'
          }}
          position="relative"
        >
          <AspectRatio
            w={{
              base: '300px',
              sm: '300px',
              md: '400px',
              lg: '500px'
            }}
            ratio={1 / 1}
            position="relative"
          >
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tumbler-hero-1711632091629.png"
              alt="hero"
              fill
            />
          </AspectRatio>
          <VStack
            position="absolute"
            top={{
              base: '30%',
              sm: '44%',
              md: '44%'
            }}
            left="82%"
            alignItems="flex-start"
          >
            <AspectRatio
              mt={5}
              w={{
                base: '80px',
                sm: '120px',
                md: '120px',
                lg: '200px'
              }}
              ratio={1 / 1}
              position="relative"
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tumbler-bottom-1711632091629.png"
                alt="bottom"
                fill
              />
            </AspectRatio>
            <AspectRatio
              mt={0}
              w={{
                base: '40px',
                sm: '40px',
                md: '50px'
              }}
              ratio={1 / 1}
              position="relative"
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/arrow-top-1711632091628.png"
                alt="arrow top"
                fill
              />
            </AspectRatio>
          </VStack>
        </VStack>
        <VStack
          w={{
            base: '100%',
            sm: '40%',
            md: '40%',
            lg: '50%'
          }}
          mt={2}
        >
          <Colors />
        </VStack>
      </Flex>
      <VStack
        data-aos="fade-down"
        w="100%"
        alignItems="flex-start"
        mt={{
          base: '30px',
          sm: '120px'
        }}
      >
        <Text
          fontSize={{
            base: 22,
            lg: 30,
            xl: 34,
            '2xl': 38
          }}
          lineHeight={1.35}
          fontWeight={700}
          textTransform="uppercase"
          textAlign="left"
          w={{
            base: '100%',
            sm: '500px',
            lg: '700px',
            xl: '900px'
          }}
          fontFamily="Inter"
        >
          ARE YOU TIRED OF YOUR DRINKWARE TUMBLING OVER AT THE SLIGHTEST NUDGE?
        </Text>
        <Text
          textStyle="gripContentSmall"
          textAlign="left"
          w={{
            base: '100%',
            sm: '500px',
            lg: '760px'
          }}
        >
          The ultimate solution to keeping your beverages secure, at the perfect
          temperature, and always within reach.
        </Text>
        <Flex w="100%" justifyContent="space-between">
          <AspectRatio
            mt={5}
            w={{
              base: '300px',
              sm: '300px',
              md: '400px',
              lg: '500px',
              xl: '600px'
            }}
            ratio={1485 / 1076}
            position="relative"
            zIndex={10}
          >
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/men-1711632091628.png"
              alt="hero"
              fill
            />
          </AspectRatio>
          <AspectRatio
            mt={{
              base: 0,
              lg: '-60px'
            }}
            w={{
              base: '240px',
              sm: '240px',
              md: '240px',
              lg: '300px',
              xl: '350px'
            }}
            ratio={1242 / 1484}
            position="relative"
            zIndex={10}
          >
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/coffee-1711632091628.png"
              alt="hero"
              fill
              style={{
                objectFit: 'cover'
              }}
            />
          </AspectRatio>
        </Flex>
      </VStack>
    </Box>
  )
}

export default Hero
